export const convertBrandCodeForDb = (code: string): string => {
  switch (code) {
    case 'dh_wb':
      return 'dh'
    case 'bibibop':
      return 'bbb'
    case 'sullivans':
    case 'sullivans_nso':
    case 'eddiemerlots':
    case 'eddiemerlots_nso':
      return 'drg'
    default:
      return code
  }
}

export const getAgentCodeFromPath = (pathname: string): string => {
  const pathSegments = pathname.split('/')
  return pathSegments[pathSegments.length - 1] || ''
}

export const getCustomerCodeFromPath = (pathname: string): string => {
  const pathSegments = pathname.split('/')
  return pathSegments[1] || ''
}
